function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDna(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1080 1080",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M205.493,895.722c-1.644,14.193 9.412,26.593 23.755,26.593l48.256,0.15c12.101,-0 22.26,-8.815 23.904,-20.767c1.046,-7.321 2.689,-16.583 5.079,-27.041l466.577,-0c2.391,10.308 4.333,19.72 5.229,27.041c1.644,11.952 11.803,20.916 23.904,20.767l48.257,-0.15c14.342,0 25.547,-12.4 23.754,-26.593c-6.872,-56.623 -38.246,-192.726 -177.637,-310.304c-26.294,18.525 -55.427,36.155 -87.399,52.887c9.263,6.873 17.032,14.044 25.398,21.215l-190.634,0c31.822,-27.041 70.218,-53.186 117.578,-76.792c257.117,-127.737 304.328,-326.887 312.993,-398.45c1.644,-14.193 -9.412,-26.593 -23.755,-26.593l-48.405,-0.15c-12.102,0 -22.261,8.815 -23.904,20.767c-1.046,7.321 -2.689,16.583 -5.08,27.041l-466.726,0c-2.391,-10.458 -4.034,-19.571 -5.08,-27.041c-1.643,-11.952 -11.802,-20.916 -23.904,-20.767l-48.256,0.15c-14.343,-0 -25.548,12.4 -23.904,26.593c7.769,64.093 46.762,229.927 238.891,355.722c-191.979,125.795 -231.122,291.629 -238.891,355.722Zm334.507,-410.104c-37.499,-20.468 -69.322,-42.429 -96.064,-65.138l191.979,-0c-26.593,22.709 -58.416,44.82 -95.915,65.138Zm195.864,-184.658c-8.666,15.537 -19.124,31.523 -31.374,47.808l-328.83,-0c-12.4,-16.285 -22.858,-32.271 -31.374,-47.808l391.578,-0Zm-391.728,478.08c8.666,-15.537 19.124,-31.523 31.374,-47.808l327.784,0c12.401,16.285 23.008,32.271 31.673,47.808l-390.831,0Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDna);
export default __webpack_public_path__ + "static/media/dna.06623ae99212c1c45e08843fb74be649.svg";
export { ForwardRef as ReactComponent };